import * as amplitude from '@amplitude/analytics-browser';
import { store } from './store';

export const amplitudeTrack = (eventName, properties, options) => {
  const {
    userProfile: { id },
  } = store.getState().profileReducer;
  const finalOptions = options?.user_id ? options : { ...options, user_id: id };
  amplitude.track(eventName, { ...properties }, finalOptions);
};
